"use client";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";

const values = [
  {
    title: "Quality First",
    description:
      "We source only the finest microcement materials and maintain strict quality control standards.",
  },
  {
    title: "Expert Support",
    description:
      "Our team of specialists provides technical guidance and application support throughout your project.",
  },
  {
    title: "Innovation",
    description:
      "Continuously developing new formulations and techniques to push the boundaries of microcement.",
  },
  {
    title: "Sustainability",
    description:
      "Committed to eco-friendly practices and sustainable material sourcing for a better future.",
  },
];

export function AboutValues() {
  return (
    <section
      id="about-values"
      className="py-24 bg-foreground/5 dark:bg-card/30 transition-colors"
      data-header-scheme="light"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-serif text-3xl md:text-4xl font-light text-foreground mb-4 tracking-tight">
            Our Values
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            The principles that guide everything we do
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {values.map((value, index) => (
            <motion.div
              key={value.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card className="border-border shadow-lg h-full bg-card">
                <CardContent className="p-8">
                  <h3 className="font-serif text-xl font-medium text-foreground mb-4 tracking-tight">
                    {value.title}
                  </h3>
                  <p className="text-muted-foreground">{value.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
